/**
 * axios 请求库
 */
import axios from 'axios';                      //  加载axios
import Router from '@/router';                  //  路由管理
import Store from '@/store';                    //  状态管理
import Storage from 'store2';                   //  本地存储
import { Message } from 'element-ui';           //  消息提示
import NProgress from 'nprogress';              //  progress bar
import 'nprogress/nprogress.css';               //  progress bar css
import LoginModal from '@/components/LoginModal/index.js'

let tokenData = {};             //	用户登录Token数据
let isRefreshing = false;       //	是否正在刷新的标记
let requestsQueue = [];         //	重试队列，每一项将是一个待执行的函数形式

axios.defaults.baseURL = process.env.VUE_APP_API_DOMAIN;                                                   //  请求域名
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = process.env.VUE_APP_API_ACCEPT;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

/**
 * 自定义参数传递，在拦截器等地方使用。比如这里我加了一个auth，可在拦截器里拿到当前的值，如果是true就要传token
 * @type {{auth: boolean, loading: boolean, showToast: boolean,showLoginDialog: boolean, response: String}}
 */
axios.defaults.custom = {
  auth: false,                //  是否需要登录验证
  loading: false,             //  是否需要loading加载
  showToast: false,           //  是否需要弹出错误信息
  showLoginDialog: false,     //  是否需要弹出登录对话框
  responseType: 'common',     //	返回数据内容，common：只返回data部分，all：返回全部
};

/**
 * 请求之前拦截器。可以使用async await 做异步操作
 * config.custom {Object} - 自定义参数
 */
axios.interceptors.request.use((config) => {
  //  需要loading加载
  if (config.custom.loading) {
    NProgress.done();
    NProgress.start();
    if (process.env.NODE_ENV == 'development') {
      console.log('加载loading');
    }
  }
  tokenData = Store.getters['token/getTokenData']; //	使用了vuex的命名空间

  //	是否需要登录权限，是否登录  否则跳转到登录界面或者是弹登录框
  if (config.custom.auth) {
    if (!tokenData.access_token) {
      //  需要弹出错误信息
      if (config.custom.showToast) {
        Message.error('请先登录');
        if (process.env.NODE_ENV == 'development') {
          console.log('请先登录');
        }
      }
      //	转到登录界面
      if (process.env.NODE_ENV == 'development') {
        console.log('转到登录界面');
      }
      setTimeout(() => {
        //  需要loading加载
        if (config.custom.loading) {
          NProgress.done();
        }
        //  直接弹出登录对话框
        if (config.custom.showLoginDialog) {
          //  弹出登录对话框
          LoginModal()
        } else {
          Router.push('/auth/login');   //  跳转到登录界面
        }
      }, (config.custom.showToast ? 2000 : 1));
      return Promise.reject(config);  //	会取消本次请求
    } else {
      //  需要loading加载
      if (config.custom.loading) {
        NProgress.inc();
      }
    }
  }
  //	如果当前用已经登录那么每次请求都把token放到头信息中发送到服务器
  if (tokenData.access_token) {
    config.headers.Authorization = tokenData.access_token;
  }
  return config;
}, (config) => {
  return Promise.reject(config)
});

/**
 * 请求之后拦截器。可以使用async await 做异步操作
 */
axios.interceptors.response.use((response) => {
  if (process.env.NODE_ENV == 'development') {
    console.log('response===========', response);
    console.log('URL===========', response.config.url);
  }
  //  需要loading加载
  if (response.config.custom.loading) {
    NProgress.done();
  }
  if (response.status !== 200) { // 服务端返回的状态码不等于200，则reject()
    return Promise.reject(response)
  }
  let result = response.data;

  if (result.ret != '0') {
    //	判断 用户未登录或已失效，并且有刷新token的值
    if (result.ret == '401' && tokenData.refresh_token != '') {
      const config = response.config; //	获得当前的请求相关配置
      //	为了防止多次同时刷新token
      if (!isRefreshing) {
        isRefreshing = true;
        //	刷新token 请求
        return axios.post('/auth/refresh', {
          refresh_token: tokenData.refresh_token,
        }, {
          custom: {
            auth: true,
          }
        }).then(res => {
          //	刷新成功，将最新的token 数据保存起来，并遍历请求队列将队列中的请求重新发送
          if (res.ret == '0') {
            tokenData = res.data;
            Store.dispatch("token/setTokenData", res.data); //	存入状态
            config.headers.Authorization = tokenData.access_token;
            //	将所有队列中的请求进行重试提交
            requestsQueue.forEach(refreshToken => refreshToken(tokenData.access_token))
            requestsQueue = []; //	将队列重置成空数组
            //	重新发送当前请求
            return axios.request(config);
          } else {
            //	转到登录界面
            if (process.env.NODE_ENV == 'development') {
              console.log('转到登录界面');
            }

            //  需要弹出错误信息
            if (response.config.custom.showToast) {
              Message.error('请先登录');
              if (process.env.NODE_ENV == 'development') {
                console.log('请先登录');
              }
            }
            setTimeout(() => {
              //  需要loading加载
              if (response.config.custom.loading) {
                NProgress.done();
              }
              //  直接弹出登录对话框
              if (response.config.custom.showLoginDialog) {
                //  弹出登录对话框


              } else {
                Router.push('/auth/login');   //  跳转到登录界面
              }
            }, (response.config.custom.showToast ? 2000 : 1));
          }
        }).finally(() => {
          isRefreshing = false;
        });
      } else {
        // 正在刷新token，将返回一个未执行resolve的promise
        return new Promise((resolve) => {
          // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
          requestsQueue.push((token) => {
            config.headers.Authorization = token;
            resolve(axios.request(config));
          });
        });
      }
    } else if (response.config.custom.showToast) {
      Message.error(result.mes);
      if (process.env.NODE_ENV == 'development') {
        console.log(result.mes);
      }
    }
  }
  return response.config.custom.responseType == 'all' ? response : response.data;
}, (response) => { // 请求错误做点什么。可以使用async await 做异步操作
  if ((response.custom.loading != undefined && response.custom.loading) || (response.config.custom.loading != undefined && response.config.custom.loading)) {
    NProgress.done();
  }
  return Promise.reject(response);
});

export {
  axios,
}
